// extracted by mini-css-extract-plugin
export default {"container":"FdPUejq8gZjVlpwyz2Fx","title":"F1aZzgGlu7Shj9e0AyYX"};